export const MOBILE_NAV_ID = 'MobileNav';
export const MOBILE_NAV_HEIGHT = 68;
